/*eslint-disable*/
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FormHelperText,
  CircularProgress,
  Checkbox,
  Button,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Dialog,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import useAuth from '../../hooks/useAuth';
import NotificationChangePassword from './NotificationForgotPassword';
import { useStyles } from './style';
import {useEffect, useState} from 'react';

const VerifyEmail: any = ({ handleClose }) => {
  const { verifyEmail } = useAuth() as any;
  const { t } = useTranslation('account');
  const [isModalOpened, setModalOpened] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const classes = useStyles();


  // Functions to show create's modal
  const handleShowModal = (): void => {
    setModalOpened(true);
  };

  const handleHideModal = (): void => {
    setModalOpened(false);
  };

  return (
    <>
      <Formik
        initialValues={{
          email: '',
          ruc: '',
          submit: null,
        }}
        validationSchema={Yup.object().shape(
          {
            email: Yup.string().when('ruc', {
              is: (ruc) => !ruc || ruc.length === 0,
              then: Yup.string()
                .email(t('validation.validEmail'))
                .max(255)
                .required(t('validation.fieldRequired')),
            }),
            ruc: Yup.string().when('email', {
              is: (email) => !email || email.length === 0,
              then: Yup.string().required(t('validation.fieldRequired')),
            }),
          },
          [['email', 'ruc']]
        )}
        onSubmit={async (
          values,
          { resetForm, setErrors, setStatus, setSubmitting }
        ) => {
          try {
            await verifyEmail(values.email, false);
            setEmail(values.email);
            resetForm();
            setStatus({ success: true });
            setSubmitting(false);
            handleShowModal();
          } catch (err) {
            console.error(err);
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          <>
            {isSubmitting ? (
              <Box display="flex" justifyContent="center" my={5} padding={10}>
                <CircularProgress />
              </Box>
            ) : (
              <form onSubmit={handleSubmit}>
                <DialogTitle sx={{ textAlign: 'center' }}>
                  <span className={classes.dialogTitle}>
                    {t('login.recoverAccount')}
                  </span>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    sx={{ textAlign: 'center', color: '#42526E' }}
                  >
                    <Typography>
                      Introduce tu <b>correo electrónico</b> registrado para
                      poder enviarte un link que te permitirá restablecer tu
                      contraseña.
                    </Typography>
                  </DialogContentText>
                  <Box py={5}>
                    <TextField
                        autoFocus
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        label={t('login.email')}
                        margin="normal"
                        name="email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="email"
                        value={values.email}
                        variant="outlined"
                    />
                  </Box>
                  {errors.submit && (
                    <Box mt={3}>
                      <FormHelperText error>{errors.submit}</FormHelperText>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Box my={1}>
                    <Grid container sx={{ textAlign: 'center' }} spacing={1}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.button}
                          fullWidth
                          type="submit"
                          variant="contained"
                          disabled={isSubmitting}
                        >
                          {t('login.recoverAccount')}
                        </Button>
                      </Grid>
                      <Grid item xs={12}>
                        <Button onClick={handleClose} color="primary">
                          {t('forgotPassword.cancel')}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </DialogActions>
              </form>
            )}
          </>
        )}
      </Formik>
      <NotificationChangePassword
        open={isModalOpened}
        onClose={handleHideModal}
        parentClose={handleClose}
        email={email}
      />
    </>
  );
};

export default VerifyEmail;
